import { CustomButton } from "@/components/custom/custom-button";
import CustomSearchInput from "@/components/custom/custom-search-input";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { DataTable } from "@/components/custom/data-table";
import { Box, Stack, styled } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import CustomPagination from "@/components/custom/custom-pagination";
import { getGlJournalEntryColumns } from "./_components/gl-journal-entry-column";
import { useGlJournalEntries } from "@/hooks/use-gl-journal-entries";
import CustomDateRangeInput from "@/components/custom/custom-date-range-input";

const RootWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const Card = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  padding: theme.spacing(2.5),
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const GlJournalEntry = () => {
  const [searchParams] = useSearchParams();

  const searchValue = searchParams.get("search") || "";
  const currentPage = Number(searchParams.get("page") || 0);
  const pageSize = Number(searchParams.get("size") || 10);
  const fromDate = searchParams.get("fromDate");
  const toDate = searchParams.get("toDate");
  const eventType = searchParams.get("eventType") || "";

  const queryParams = {
    page: currentPage,
    size: pageSize,
    search: searchValue || undefined,
    fromDate: fromDate || undefined,
    toDate: toDate || undefined,
    eventType: eventType || undefined,
  };

  const { data, isLoading, isError } = useGlJournalEntries(true, queryParams);

  return (
    <RootWrapper>
      <Card>
        <Stack
          direction="row"
          spacing={3}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={2} mb={2}>
            <CustomSearchInput
              paramKey="search"
              placeholder="Search by ledger no. or description..."
            />
            <CustomDateRangeInput fromKey="fromDate" toKey="toDate" />
          </Stack>

          <CustomButton
            variantType="outline"
            endIcon={<FileDownloadOutlinedIcon fontSize="small" />}
            onClick={() => {}}
            isLoading={false}
            sx={{ height: 35 }}
          >
            Export
          </CustomButton>
        </Stack>

        <DataTable
          data={data?.data?.data || []}
          columns={getGlJournalEntryColumns()}
          isLoading={isLoading}
          isError={isError}
        />

        <CustomPagination
          total={data?.data?.total ?? 0}
          perPageOptions={[5, 10, 20, 50, 100]}
        />
      </Card>
    </RootWrapper>
  );
};

export default GlJournalEntry;
